import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { useAccordionPanelContext } from '../AccordionPanel.Context/index.es.js';

const AccordionPanelContent = ({ children })=>{
    const [{ open, size, onCard, ariaId }] = useAccordionPanelContext();
    return jsx("div", {
        "aria-hidden": !open,
        className: classNames('accordion-panel-content', size, {
            card: onCard,
            open
        }),
        "data-testid": "accordion-panel-content",
        id: ariaId,
        children: children
    });
};
AccordionPanelContent.displayName = 'AccordionPanelContent';

export { AccordionPanelContent };
//# sourceMappingURL=AccordionPanelContent.es.js.map
